import React, { useContext, useEffect } from 'react';
import DescriptionIcon from '@mui/icons-material/Description';
import CompanyRow from '../company-row';
import { MatchCompaniesStyled, SkeletonContainerStyled, SkeletonStyled } from './match-companies.styled';
import { UploadCompaniesContext } from '../../../../../../../../providers/upload-companies-provider';
import { ArrowRight, WandIcon } from 'lucide-react';

export const MatchCompanies = () => {
    const { selectedCompanies, getValidationForCompanies, loading } = useContext(UploadCompaniesContext);

    useEffect(() => {
        getValidationForCompanies();
        //eslint-disable-next-line
    }, []);

    return (
        <>
            {loading &&
                Array(5)
                    .fill(0)
                    .map(() => (
                        <SkeletonContainerStyled>
                            <SkeletonStyled width={39} height={26} />
                            <SkeletonStyled width={'100%'} height={52} />
                            <SkeletonStyled width={24} height={24} />
                        </SkeletonContainerStyled>
                    ))}
            {!loading && (
                <MatchCompaniesStyled>
                    <div className="step-visualization">
                        <DescriptionIcon className="description" />
                        <ArrowRight className="arrow" />
                        <div className="logo">
                            zaplify <WandIcon className="icon" />
                        </div>
                    </div>
                    <div className="companies-container">
                        {selectedCompanies.map((s, idx) => (
                            <div key={`${s.name}-${idx}`}>
                                <CompanyRow selectedCompany={s} idx={idx} />
                            </div>
                        ))}
                    </div>
                </MatchCompaniesStyled>
            )}
        </>
    );
};
